import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Routes
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import ErrorPage from "./ErrorPage";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { ToastContainer, toast } from 'react-toastify';
import { ThemeProvider } from "@mui/material"
import { createTheme } from "@mui/material"
import { LicenseInfo } from '@mui/x-license-pro';
import { BrowserRouter } from 'react-router-dom';
import Login from './components/Login/Login'
import ForgotPassword from './components/Login/ForgotPassword'
import UserManagement from "./components/Users/UserManagement"
import AgenciesManagement from "./components/Agency/AgenciesManagement"
import CentersManagement from "./components/Center/CentersManagement"
import Profile from "./components/Profile"
import Booking from "./components/Booking/Booking";
import BookingsManagement from "./components/Booking/BookingsManagement";
import NavBar_v2 from "./components/NavBar_v2/NavBar_v2";
import BookingsDetails from "./components/Booking/BookingDetails/BookingDetails";
import SlideRoutes from 'react-slide-routes';
import CreateAccount from "./components/Login/CreateAccount";
import Statistics from './components/Stats/Statistics';


LicenseInfo.setLicenseKey('c0e66f40f94bdbc8491d9140abfc39dbTz01NTgyMCxFPTE3MDIxMzY2ODg4ODcsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');


const theme = createTheme({
  palette: {
    primary: {
      main: '#F5A10F',
      main_light: '#fab843',
      main_very_light: '#fff7e8'
    },
    secondary: {
      main: '#FDDDFFF',
    },
    paid: {
      main: '#FFFFFF',
    },
    thirdry: {
      main: '#404040',
    },
    neutral: {
      main: '#757575',
      contrastText: '#fff',
    },
  }
});



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ToastContainer />
      <ThemeProvider theme={theme}>

        <NavBar_v2 />

        <Routes>

          <Route exact path="/" element={<Login />} />
          <Route path="/Booking" element={<Booking />} />
          <Route path="/bookings-management" element={<BookingsManagement />} />
          <Route path='bookings-management/:booking_id' element={<BookingsDetails />} />
          <Route path="/users-management" element={<UserManagement />} />
          <Route path="/agencies-management" element={<AgenciesManagement />} />
          <Route path="/centers-management" element={<CentersManagement />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/statistics" element={<Statistics />} />
        </Routes>

      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);